module.exports = __webpack_public_path__ + "img/tools.c6d96745.svg";